<template>
  <BarPlotChart
    :chart-width="900"
    :chart-height="446"
    :chart-margin="{ top: 32, right: 128, bottom: 64, left: 64 }"
    :data="entries"
    :advencedMode="advencedMode"
    :sensitiveCaseDuration="sensitiveCaseDuration"
    :useExtendedTimeRanges="data.useExtendedTimeRanges"
  />
</template>

<script>
import Computing from '@/components/Analysis/Computing';
import BarPlotChart from '@/components/Chart/BarPlot';

export default {
  components: {
    BarPlotChart,
  },

  mixins: [Computing],

  props: {
    data: {
      type: Object,
      required: true,
    },

    index: {
      type: Number,
      default: -1,
    },

    advencedMode: {
      type: Boolean,
      default: false,
    },

    sensitiveCaseDuration: {
      type: Number,
      default: 45,
    },
  },

  computed: {
    entries() {
      let values = this.data.sites.map(e => {
        return {
          site: e.name,
          r010: e.details.collaboratorsByTimeRanges[0].count,
          r1120: e.details.collaboratorsByTimeRanges[1].count,
          r2130: e.details.collaboratorsByTimeRanges[2].count,
          r3140: e.details.collaboratorsByTimeRanges[3].count,
          r4150: e.details.collaboratorsByTimeRanges[4].count,
          r5160: e.details.collaboratorsByTimeRanges[5].count,

          r030: e.details.collaboratorsByTimeRanges[0].count + e.details.collaboratorsByTimeRanges[1].count + e.details.collaboratorsByTimeRanges[2].count,
          r3160: e.details.collaboratorsByTimeRanges[3].count + e.details.collaboratorsByTimeRanges[4].count + e.details.collaboratorsByTimeRanges[5].count,
          r60: e.details.collaboratorsByTimeRanges[6].count,

          r61120: e.details.collaboratorsByTimeRanges[6].count + e.details.collaboratorsByTimeRanges[7].count,
          r120: e.details.collaboratorsByTimeRanges[8].count,

          t45: this.calculateT45(e.details),

          total:
            e.details.collaboratorsByTimeRanges[0].count +
            e.details.collaboratorsByTimeRanges[1].count +
            e.details.collaboratorsByTimeRanges[2].count +
            e.details.collaboratorsByTimeRanges[3].count +
            e.details.collaboratorsByTimeRanges[4].count +
            e.details.collaboratorsByTimeRanges[5].count +
            e.details.collaboratorsByTimeRanges[6].count +
            e.details.collaboratorsByTimeRanges[7].count +
            e.details.collaboratorsByTimeRanges[8].count,
        };
      });

      values.unshift({
        site: this.$t('actualSites', this.data.actualSites.length),
        r010: this.data.collaboratorsByTimeRanges[0].count,
        r1120: this.data.collaboratorsByTimeRanges[1].count,
        r2130: this.data.collaboratorsByTimeRanges[2].count,
        r3140: this.data.collaboratorsByTimeRanges[3].count,
        r4150: this.data.collaboratorsByTimeRanges[4].count,
        r5160: this.data.collaboratorsByTimeRanges[5].count,

        r030: this.data.collaboratorsByTimeRanges[0].count + this.data.collaboratorsByTimeRanges[1].count + this.data.collaboratorsByTimeRanges[2].count,
        r3160: this.data.collaboratorsByTimeRanges[3].count + this.data.collaboratorsByTimeRanges[4].count + this.data.collaboratorsByTimeRanges[5].count,
        r60: this.data.collaboratorsByTimeRanges[6].count,

        r61120: this.data.collaboratorsByTimeRanges[6].count + this.data.collaboratorsByTimeRanges[7].count,
        r120: this.data.collaboratorsByTimeRanges[8].count,

        t45: this.calculateT45(this.data),

        total:
          this.data.collaboratorsByTimeRanges[0].count +
          this.data.collaboratorsByTimeRanges[1].count +
          this.data.collaboratorsByTimeRanges[2].count +
          this.data.collaboratorsByTimeRanges[3].count +
          this.data.collaboratorsByTimeRanges[4].count +
          this.data.collaboratorsByTimeRanges[5].count +
          this.data.collaboratorsByTimeRanges[6].count +
          this.data.collaboratorsByTimeRanges[7].count +
          this.data.collaboratorsByTimeRanges[8].count,
      });

      return values;
    },
  },

  methods: {
    calculateT45(details) {
      if (this.sensitiveCaseDuration >= 60) {
        return (
          details.collaboratorsByTimeRanges[0].count +
          details.collaboratorsByTimeRanges[1].count +
          details.collaboratorsByTimeRanges[2].count +
          details.collaboratorsByTimeRanges[3].count +
          details.collaboratorsByTimeRanges[4].count +
          details.collaboratorsByTimeRanges[5].count +
          details.collaboratorsByTimeRanges[6].count
        );
      } else if (this.sensitiveCaseDuration < 60 && this.sensitiveCaseDuration >= 51) {
        return (
          details.collaboratorsByTimeRanges[0].count +
          details.collaboratorsByTimeRanges[1].count +
          details.collaboratorsByTimeRanges[2].count +
          details.collaboratorsByTimeRanges[3].count +
          details.collaboratorsByTimeRanges[4].count +
          details.collaboratorsByTimeRanges[5].count * ((this.sensitiveCaseDuration - 50) / 10)
        );
      } else if (this.sensitiveCaseDuration <= 50 && this.sensitiveCaseDuration >= 41) {
        return (
          details.collaboratorsByTimeRanges[0].count +
          details.collaboratorsByTimeRanges[1].count +
          details.collaboratorsByTimeRanges[2].count +
          details.collaboratorsByTimeRanges[3].count +
          details.collaboratorsByTimeRanges[4].count * ((this.sensitiveCaseDuration - 40) / 10)
        );
      } else if (this.sensitiveCaseDuration <= 40 && this.sensitiveCaseDuration >= 31) {
        return (
          details.collaboratorsByTimeRanges[0].count +
          details.collaboratorsByTimeRanges[1].count +
          details.collaboratorsByTimeRanges[2].count +
          details.collaboratorsByTimeRanges[3].count * ((this.sensitiveCaseDuration - 30) / 10)
        );
      } else if (this.sensitiveCaseDuration <= 30 && this.sensitiveCaseDuration >= 21) {
        return (
          details.collaboratorsByTimeRanges[0].count +
          details.collaboratorsByTimeRanges[1].count +
          details.collaboratorsByTimeRanges[2].count * ((this.sensitiveCaseDuration - 20) / 10)
        );
      } else if (this.sensitiveCaseDuration <= 20 && this.sensitiveCaseDuration >= 11) {
        return details.collaboratorsByTimeRanges[0].count + details.collaboratorsByTimeRanges[1].count;
      } else {
        return details.collaboratorsByTimeRanges[0].count;
      }
    },
  },
};
</script>
